import React from 'react';
import { useCompany } from './useCompany';
import { fileUrl } from '../../services/api';

/**
 * Company letterhead — logo, name, address and phone. Hidden on screen
 * (display: none) and revealed inside the print iframe so every printed
 * document (invoice, estimate, PO, report, list) carries the company header.
 */
export default function PrintLetterhead() {
  const company = useCompany();
  if (!company) return null;

  const address = [
    company.address_line1,
    company.address_line2,
    [company.city, company.state, company.postal_code].filter(Boolean).join(', '),
    company.country && company.country !== 'US' ? company.country : '',
  ].filter(Boolean).join(', ');

  return (
    <div className="print-letterhead">
      {company.logo_path && (
        <img className="print-letterhead-logo" src={fileUrl(company.logo_path)} alt="" />
      )}
      <div className="print-letterhead-info">
        <div className="print-letterhead-name">{company.name}</div>
        {address && <div className="print-letterhead-line">{address}</div>}
        {company.phone && <div className="print-letterhead-line">Phone: {company.phone}</div>}
        {company.email && <div className="print-letterhead-line">{company.email}</div>}
      </div>
    </div>
  );
}
